import { render, staticRenderFns } from "./StockPrintTag.vue?vue&type=template&id=2b8eceba&scoped=true&"
import script from "./StockPrintTag.vue?vue&type=script&lang=js&"
export * from "./StockPrintTag.vue?vue&type=script&lang=js&"
import style0 from "./StockPrintTag.vue?vue&type=style&index=0&id=2b8eceba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8eceba",
  null
  
)

export default component.exports